var _rect, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.65625,
    y: 0.918945,
    width: 45.1923,
    height: 44.2308,
    rx: 22.1154,
    fill: "url(#paint0_linear_4818_126915)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.2539 19.0342L23.2539 24.0342L15.2539 19.0342V17.0342L23.2539 22.0342L31.2539 17.0342M31.2539 15.0342H15.2539C14.1439 15.0342 13.2539 15.9242 13.2539 17.0342V29.0342C13.2539 29.5646 13.4646 30.0733 13.8397 30.4484C14.2148 30.8235 14.7235 31.0342 15.2539 31.0342H31.2539C31.7843 31.0342 32.293 30.8235 32.6681 30.4484C33.0432 30.0733 33.2539 29.5646 33.2539 29.0342V17.0342C33.2539 16.5037 33.0432 15.995 32.6681 15.62C32.293 15.2449 31.7843 15.0342 31.2539 15.0342Z",
    fill: "#1C1C1C"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.985d3265133f1844fb760f2104d1cb4c.svg";
export { ForwardRef as ReactComponent };